import { render, staticRenderFns } from "./ServicesForm.vue?vue&type=template&id=1c205e2e&scoped=true&"
import script from "./ServicesForm.vue?vue&type=script&lang=js&"
export * from "./ServicesForm.vue?vue&type=script&lang=js&"
import style0 from "./ServicesForm.vue?vue&type=style&index=0&id=1c205e2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c205e2e",
  null
  
)

export default component.exports